// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21H1V11H23V21ZM5 14V16H17V14H5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9H1V3H23V9ZM5 7.00391H7.00391V5.00391H7V5H5V7.00391ZM9 7.00391H11.0039V5.00391H11V5H9V7.00391ZM13 7.00391H15.0039V5.00391H15V5H13V7.00391Z"}}]};

const WebFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'web-filled',
    ref,
    icon: element,
  },
));

WebFilledIcon.displayName = 'WebFilledIcon';

export default WebFilledIcon;
